import React, { ReactNode } from 'react'

import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import { Tooltip } from '@mui/material'

interface Props {
  title: ReactNode
}

export const HelpTooltip: React.FC<Props> = ({ title }) => (
  <Tooltip title={title} arrow>
    <HelpOutlineIcon sx={{ fontSize: 14, ml: 0.5, verticalAlign: 'middle' }} />
  </Tooltip>
)
